import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-254b8399"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "credit-limit-form"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("不限制");

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "授信额度", -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "元", -1));

const _hoisted_5 = {
  class: "dialog-footer"
};

const _hoisted_6 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("确定");

import { ref, computed, watch, reactive } from 'vue';
import { ElMessage } from 'element-plus';
import Axios from '@/request/createAxiosInstalce';
export default {
  name: 'credit-limit-modal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    currentSalesman: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const dialogVisible = computed({
      get: () => props.modelValue,
      set: val => emit('update:modelValue', val)
    });
    const formData = reactive({
      supUserId: '',
      isCreditLimited: 0,
      creditLimitAmount: 0
    });
    const loading = ref(false);
    watch(() => props.currentSalesman, newVal => {
      if (newVal) {
        formData.supUserId = newVal.supUserId;
        formData.isCreditLimited = newVal.isCreditLimited !== undefined ? newVal.isCreditLimited : 0;
        formData.creditLimitAmount = newVal.creditLimitAmount || 0;
      }
    }, {
      immediate: true
    });

    function handleClosed() {
      formData.supUserId = '';
      formData.isCreditLimited = 0;
      formData.creditLimitAmount = 0;
    }

    function handleSave() {
      if (formData.isCreditLimited === 1 && (!formData.creditLimitAmount || formData.creditLimitAmount <= 0)) {
        ElMessage.warning('请输入有效的授信额度');
        return;
      }

      loading.value = true;
      const params = {
        supUserId: formData.supUserId,
        isCreditLimited: formData.isCreditLimited,
        creditLimitAmount: formData.isCreditLimited === 1 ? formData.creditLimitAmount : null
      };
      Axios.post('/admin/creditManage/creditUser/saveCreditAmount', params).then(res => {
        const {
          success,
          msg
        } = res.data;

        if (success) {
          ElMessage.success('保存成功');
          dialogVisible.value = false;
          emit('success');
        } else {
          ElMessage.error(msg || '保存失败');
        }
      }).catch(() => {
        ElMessage.error('网络错误，请稍后重试');
      }).finally(() => {
        loading.value = false;
      });
    }

    return (_ctx, _cache) => {
      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "编辑授信额度",
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        width: "400px",
        "close-on-click-modal": false,
        onClosed: handleClosed
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_5, [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSave,
          loading: loading.value
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_radio_group, {
          modelValue: formData.isCreditLimited,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.isCreditLimited = $event),
          class: "limit-radio-group"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            label: 0
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          }), _createVNode(_component_el_radio, {
            label: 1
          }, {
            default: _withCtx(() => [_hoisted_3, _createVNode(_component_el_input_number, {
              modelValue: formData.creditLimitAmount,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.creditLimitAmount = $event),
              min: 0,
              precision: 2,
              disabled: formData.isCreditLimited === 0,
              "controls-position": "right",
              style: {
                "width": "160px",
                "margin-left": "8px",
                "margin-right": "8px"
              }
            }, null, 8, ["modelValue", "disabled"]), _hoisted_4]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};